import {
  getHookFormTyped,
} from '../../../../utils/helpers';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormTrigger,
} from 'react-hook-form';
import { CommonInput } from '../../../../components/common/Forms/Input';
import { DatePickerInput } from '../../../../components/common/Forms/DatePickerInput';
import { FormRow } from '../../../../components/common/Forms/Forms.styled';
import { useOverflowTimeSelectValidation } from './overflowHooks';

export type AppointmentSubformType = {
  appointment: {
    apptDate?: string;
    apptTime?: string;
  };
};

type IFormAppointmentsProps<T extends AppointmentSubformType> = {
  register: UseFormRegister<T>;
  control: Control<T>;
  errors: FieldErrors<T>;
  getValues: UseFormGetValues<T>;
  trigger: UseFormTrigger<T>;
};

export const OverflowTimeSelect = <T extends AppointmentSubformType>({
  ...rest
}: IFormAppointmentsProps<T>) => {
  const { register, errors, control, getValues, trigger } = getHookFormTyped<
    AppointmentSubformType,
    T
  >(rest);
  const { t } = useCommonTranslation();
  const { minDate, maxDate, validateApptDate, validateApptTime } =
    useOverflowTimeSelectValidation({
      getApptDateValue: () => getValues().appointment.apptDate,
    });

  return (
    <FormRow>
      <Controller
        control={control}
        name="appointment.apptDate"
        rules={{
          validate: validateApptDate,
        }}
        render={({ field }) => {
          return (
            <DatePickerInput
              name="appointment.apptDate"
              label={t('appointment-date')}
              placeholder={t('appointment-date')}
              onChange={(value) => {
                field.onChange(value);
                trigger('appointment.apptTime');
              }}
              minDate={minDate}
              maxDate={maxDate}
              hasError={Boolean(errors.appointment?.apptDate)}
              helperText={errors.appointment?.apptDate?.message}
              value={field.value}
              required
            />
          );
        }}
      />
      <CommonInput
        {...register('appointment.apptTime', {
          validate: validateApptTime,
        })}
        placeholder={t('appointment-time')}
        label={t('appointment-time')}
        hasError={Boolean(errors?.appointment?.apptTime)}
        helperText={errors?.appointment?.apptTime?.message}
        required
      />
    </FormRow>
  );
};
